import { render, staticRenderFns } from "./Termine.vue?vue&type=template&id=1bce28aa&scoped=true"
import script from "./Termine.vue?vue&type=script&lang=js"
export * from "./Termine.vue?vue&type=script&lang=js"
import style0 from "./Termine.vue?vue&type=style&index=0&id=1bce28aa&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bce28aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1bce28aa')) {
      api.createRecord('1bce28aa', component.options)
    } else {
      api.reload('1bce28aa', component.options)
    }
    module.hot.accept("./Termine.vue?vue&type=template&id=1bce28aa&scoped=true", function () {
      api.rerender('1bce28aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Termine.vue"
export default component.exports